import { call, takeEvery } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import { filterProgram, displaySelectionOrderSelector, displaySelectionItemOrderSelector } from './helpers'
import { addItemToListAndFractal } from './helpers/updateOrderListAndFractal'
import { createNewSelection, createNewSelectionDisplay } from './helpers/createItems'
import itemSelectionsDisplayTypes from '../../constants/itemSelectionsDisplayTypes'


function* addItem({payload}) {
    if(payload.values && payload.values.type && payload.values.title) { 
        const { values } = yield payload
        const { type, title } = yield values

        if(itemSelectionsDisplayTypes.SHOWTIMES === type) {
            values.filterValue = 'showTimes'
        }

        const filterType = yield values.filterType ? values.filterType : null
        const filterValue = yield values.filterValue ? values.filterValue : null
        const expireDate = yield values.expireDate ? values.expireDate : null
        const showInApp = yield values.showInApp ? values.showInApp : false
        const style = yield values.style ? values.style : 'Classic'
        const trailerAutoplay = yield values.trailerAutoplay ? values.trailerAutoplay : false
        const cinemasFilter = yield values.cinemasFilter ? values.cinemasFilter : null

        const newSelection = yield call(createNewSelection, title, filterType, filterValue, expireDate, showInApp, style, trailerAutoplay, cinemasFilter) 

        if(!newSelection) {
            return yield false
        }

        const newSelectionDisplay = yield call(createNewSelectionDisplay, type, newSelection.payload.pk) 

        if(!newSelectionDisplay) {
            return yield false
        }

        yield call(addItemToListAndFractal, newSelectionDisplay.payload.pk, actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ORDER, actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ITEM_ORDER, displaySelectionOrderSelector, displaySelectionItemOrderSelector)
        yield call(filterProgram)
    }
}


function* watchAddDisplaySelection() {
    try {
        yield takeEvery(actionTypes.ITEMSELECTIONSDISPLAY_REQUEST_ADD_ITEM, addItem)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}


export default watchAddDisplaySelection;